import React from "react";
import styles from "./InfoWidget.module.css"

const InfoWidget = (props) => {
    const {icon, label, val} = props
    return (
        <div {...props} className={`${styles.widgets}`}>
            <div style={{width:"20%"}} ><img src={icon} alt="icon" width="100%" /></div>
            <div>
                {label==="Area Surveyed" ? <div>{val}&sup2;</div> : <div>{val}</div>}
                <div>{label}</div>
            </div>
        </div>
    );
};

export default InfoWidget;
